/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_SpendcapInputs */

const en_mk_mx_spendcap = /** @type {(inputs: Mk_Mx_SpendcapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spending cap per agent`)
};

const id_mk_mx_spendcap = /** @type {(inputs: Mk_Mx_SpendcapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas belanja per agen`)
};

/**
* | output |
* | --- |
* | "Spending cap per agent" |
*
* @param {Mk_Mx_SpendcapInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_spendcap = /** @type {((inputs?: Mk_Mx_SpendcapInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_SpendcapInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_spendcap(inputs)
	return en_mk_mx_spendcap(inputs)
});